import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import {additionalEmailAPI, IAdditionalEmail} from 'entities/notification';
import {userSelector} from 'entities/user';

import NotifyChannelSection from '../NotifyChannel/NotifyChannelSection';

import AdditionalEmailRow from './AdditionalEmailRow';
import AdditionalEmailModal from './AdditionalEmailModal';

const AdditionalEmails: React.FC = () => {
    const user = useSelector(userSelector);

    const mainEmail = {
        id: -1,
        email: user?.email,
        description: '',
        active: user?.email_active,
        is_main: true,
    } as IAdditionalEmail;

    return (
        <NotifyChannelSection
            api={additionalEmailAPI}
            title={t`Адреса для уведомлений`}
            limit={user?.tariff.additional_emails_max_count_limit}
            firstColumn={{label: t`E-mail`, sort: 'email'}}
            create={{label: t`Добавить E-mail`, exceededType: 'emails', Modal: AdditionalEmailModal}}
            renderRow={(item) => <AdditionalEmailRow key={item.id} item={item}/>}
            mainItem={{item: mainEmail, active: !!user?.email_active}}
        />
    );
};

export default AdditionalEmails;
